import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const data = [
  { Reports: "Report A", ReportCount: 30 },
  { Reports: "Report B", ReportCount: 50 },
  { Reports: "Report C", ReportCount: 70 },
  { Reports: "Report D", ReportCount: 90 },
  { Reports: "Report E", ReportCount: 110 },
];

const colors = ["#5662be", "#efc58a", "#b0b8f4", "#2b3779", "#fdb84c"];

const CustomBar = (props) => {
  const { x, y, width, height, fill } = props;
  const borderRadius = 8; // Adjust the radius size

  return (
    <path
      d={`
        M${x},${y} 
        h${width - borderRadius} 
        a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},${borderRadius} 
        v${height - 2 * borderRadius} 
        a${borderRadius},${borderRadius} 0 0 1 -${borderRadius},${borderRadius} 
        h-${width - borderRadius} 
        z
      `}
      fill={fill}
    />
  );
};

const BarChartComponent = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart layout="vertical" data={data} margin={{ top: 5, right: 20, left: -70, bottom: 40 }}>
        <CartesianGrid stroke="#d6d6d6" strokeDasharray="0 0" horizontal={false} vertical={true} />
        <XAxis
          type="number"
          tick={{ fontSize: "14px", fill: "#999" }}
          axisLine={{ stroke: "rgb(167, 167, 167)", strokeWidth: 1.7 }}
          label={{
            value: "Report Count",
            position: "insideLeft",
            offset: 0,
            style: { fontSize: "14px", fill: "#999" },
            dy: 30,
          }}
        />
        <YAxis
          dataKey="Reports"
          type="category"
          width={200}
          tick={{ fontSize: 14, fill: "#999" }}
          axisLine={{ stroke: "rgb(167, 167, 167)", strokeWidth: 1.7 }}
        />
        <Tooltip
          cursor={{ fill: "transparent" }}
          labelStyle={{ fontSize: "14px", color: "#000" }}
          itemStyle={{ fontSize: "14px", color: "#999" }}
          formatter={(value) => [`${value}k`, "Reports Count"]}
        />
        <Bar
          dataKey="ReportCount"
          isAnimationActive={false}
          shape={(props) => {
            const color = colors[props.index % colors.length];
            return <CustomBar {...props} fill={color} />;
          }}
          barSize={30}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
